/* eslint-disable import/prefer-default-export */
export const IDENTIFIER_DEF = [
  {
    label: 'PRO #',
    key: 'proNumber',
    value: '123456',
  },
  {
    label: 'P/U #',
    key: 'puNumber',
    value: '654321',
  },
  {
    label: 'Ref #',
    key: 'refNumber',
    value: '112233',
  },
  {
    label: 'PO #',
    key: 'poNumber',
    value: '665544',
  },
  {
    label: 'Customer BOL',
    key: 'customerBol',
    value: '332211',
  },
  {
    label: 'QUOTE #',
    key: 'quoteNumber',
    value: '887766',
  },
  {
    label: 'BOL',
    key: 'bolNumber',
    value: '776655',
  },
  {
    label: 'Inv #',
    key: 'invoiceNumber',
    value: '112233',
  },
];
